import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/yinghui_logo.png'
import _imports_1 from '@/assets/qrcode/img_qr_code.jpg'


const _withScopeId = n => (_pushScopeId("data-v-de1bc1d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "foot-qr-container" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"foot-qr-title-div\" data-v-de1bc1d2><img class=\"foot-qr-title-img\" src=\"" + _imports_0 + "\" data-v-de1bc1d2><span class=\"font-qr-title margin-left-10\" data-v-de1bc1d2>荧辉科技</span></div><span class=\"font-qr-text margin-top-15\" data-v-de1bc1d2>企业信用不良记录维护，包括行政处罚、司法诉讼、裁判文书、开庭公告、互联网第三方信用平台记录、被执行人、失信被执行人、不良行为及黑名单等。联系我们为您提供免费技术咨询，帮您解决企业信用问题。</span><span class=\"font-qr-code-text margin-top-20\" data-v-de1bc1d2>扫码沟通</span>", 3)
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "foot-qr-item-img_second_bg" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "font-qr-code",
    src: _imports_1
  })
], -1))
const _hoisted_6 = [
  _hoisted_5
]

import {isShowQrCodeDialog} from "@/views/data/CommonData";


export default /*#__PURE__*/_defineComponent({
  __name: 'foot-qr',
  setup(__props) {

const onQRCodeClick = () => {
  isShowQrCodeDialog.value = true
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", {
      class: "foot-qr-item-img_bg margin-top-10",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (onQRCodeClick()))
    }, _hoisted_6)
  ]))
}
}

})